import britishCurriculumLogo from "../../assets/British Curriculum.png";
import nationalCurriculumLogo from "../../assets/National Curriculum.png";
import americanCurriculumLogo from "../../assets/American Curriculum.png";

const curricula = [
  {
    id: "british",
    title: "British Curriculum",
    subtitle: "Cambridge / IGCSE / A & AS level",
    items: [
      "Certified teachers",
      "International Assessments",
      "AI Powered learning",
      "University pathway assistance",
      "Global recognition",
    ],
    logo: britishCurriculumLogo,
    logoAlt: "Cambridge Assessment International Education",
  },
  {
    id: "national",
    title: "National Curriculum",
    subtitle: "NCF / NIOS",
    items: [
      "NCERT aligned syllabus",
      "Subject flexibility & split",
      "Flexible Exams",
      "Credit Transfer facility",
      "Global Recognition",
    ],
    logo: nationalCurriculumLogo,
    logoAlt: "NIOS National Institute of Open Schooling",
  },
  {
    id: "american",
    title: "American Curriculum",
    subtitle: "NWAC",
    items: [
      "American High School Diploma",
      "No rigid streams",
      "Project based grading",
      "SAT / ACT aligned",
      "Global recognition",
    ],
    logo: americanCurriculumLogo,
    logoAlt: "NWAC Northwest Accreditation Commission",
  },
];

function CurriculumCard({ title, subtitle, items, logo, logoAlt }) {
  return (
    <article className="flex h-full flex-col rounded-2xl bg-[#f5f5f5] p-6 shadow-sm ring-1 ring-black/[0.04] sm:p-7">
      <h3 className="text-lg font-bold text-brand sm:text-xl">{title}</h3>
      <p className="mt-2 font-bold text-ink">{subtitle}</p>
      <ul className="mt-5 list-disc space-y-2.5 pl-5 text-pretty text-sm leading-relaxed text-ink/85 marker:text-brand sm:text-[0.9375rem]">
        {items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      <div className="mt-auto flex min-h-[5.5rem] items-center justify-center border-t border-brand/10 pt-6 sm:min-h-[6.5rem]">
        <img
          src={logo}
          alt={logoAlt}
          className="h-24 w-auto max-h-32 max-w-full object-contain object-center sm:h-28 sm:max-h-36 md:h-32 md:max-h-40"
          loading="lazy"
        />
      </div>
    </article>
  );
}

function HomeCurriculums() {
  return (
    <section
      className="relative overflow-hidden bg-white py-16 sm:py-20 lg:py-24"
      aria-labelledby="home-curriculums-heading"
    >
      <div className="relative mx-auto max-w-7xl px-4 sm:px-8 md:px-10 lg:px-8">
        <header className="mx-auto max-w-3xl text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-brand sm:text-[0.8125rem]">
            Board pathways
          </p>
          <h2
            id="home-curriculums-heading"
            className="mt-4 text-balance text-3xl font-bold tracking-tight text-ink sm:mt-5 sm:text-4xl md:text-[2.375rem] md:leading-tight"
          >
            Curriculums Designed for Every Learner
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-pretty text-base leading-relaxed text-ink/65 sm:mt-5 sm:text-lg">
            Choose the board that aligns with your career goals.
          </p>
        </header>

        <div className="mt-12 grid gap-6 sm:mt-14 md:grid-cols-2 md:gap-7 lg:grid-cols-3 lg:gap-8">
          {curricula.map((c) => (
            <CurriculumCard key={c.id} {...c} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default HomeCurriculums;
